<template>

    <v-ons-splitter class="main-content">
        <v-ons-splitter-side
                v-bind:swipeable="sidebar_swipeable" width="250px" collapse="" side="left"
                :open="sidebarOpen" @update:open="open => setSidebarOpen(open)">
            <v-ons-page>
                <v-ons-list class="main-menu">

                    <div>
                        <img src="/logo_v2.png" class="logo">
                    </div>

                    <v-ons-list-item tappable modifier="chevron" v-on:click="home"
                                     v-show="embed.enabled == false && page_stack.length > 1">
                        <div class="center menu-text">
                            <gtc-button class="round secondary" icon="fal fa-user"></gtc-button>
                            Stores
                        </div>
                    </v-ons-list-item>
                    <v-ons-list-item tappable modifier="chevron" v-on:click="menu"
                                     v-show="embed.enabled && page_stack.length > 1">
                        <div class="center menu-text">
                            <gtc-button class="round secondary" icon="fal fa-user"></gtc-button>
                            Menu
                        </div>
                    </v-ons-list-item>

                    <!-- User links -->
                    <template v-if="user && browse_only == false">
                        <v-ons-list-item v-on:click="myAccount">
                            <div class="center menu-text">
                                <gtc-button class="round secondary" icon="fal fa-user" data-test-id="btn-sidebar-account"/>
                                My account
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item v-on:click="orders">
                            <div class="center menu-text">
                                <gtc-button class="round secondary" icon="fal fa-list-alt" data-test-id="btn-sidebar-orders"/>
                                My orders
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item v-on:click="signout">
                            <div class="center menu-text">
                                <gtc-button class="round secondary" icon="fal fa-sign-out-alt" data-test-id="btn-sidebar-logout"/>
                                Logout
                            </div>
                        </v-ons-list-item>
                    </template>

                    <!-- Guest links -->
                    <template v-if="user == null && browse_only == false">
                        <v-ons-list-item v-on:click="login">
                            <div class="center menu-text">
                                <gtc-button class="round secondary" icon="fal fa-user" data-test-id="btn-sidebar-login"/>
                                Login
                            </div>
                        </v-ons-list-item>
                    </template>
                </v-ons-list>

                <!-- Special links -->
                <div class="term-conditions-text">
                    <v-ons-list-item tappable>
                        <div class="center for-businesses-link">
                            <a href="https://thegoodtill.com/product-features/goodeats-campaign/"
                                target="_blank">For Businesses</a>
                        </div>
                    </v-ons-list-item>

                    <v-ons-list-item v-on:click="eula">
                        <div class="center menu-text">End User License Agreement</div>
                    </v-ons-list-item>
                </div>

            </v-ons-page>
        </v-ons-splitter-side>
        <v-ons-splitter-content>
            <v-ons-navigator
                swipeable
                swipe-target-width="200px"
                :page-stack="page_stack"
                :pop-page="goBack">
            </v-ons-navigator>
        </v-ons-splitter-content>
    </v-ons-splitter>


</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {

    created() {

        /*
         * This is some black magic stuff from an Onsen router example. I don't understand it, but it's required to
         * allow navigation to our child pages as defined in the routes list. Best to leave it alone.
         *
         * Define how routes should be mapped to the page stack.
         * This assumes all the routes contain VOnsPage components
         * and are provided in the 'default' view.
         * For nested named routes or routes that for some reason
         * should not be mapped in VOnsNavigator, filter them out here.
         */
        const map_route_stack = route => this.page_stack = route.matched.map(m => m.components.default)
        /* Set initial page_stack depending on current
         * route instead of always pushing 'Home' page
         */
        map_route_stack(this.$route)

        this.$router.beforeEach((to, from, next) => {

            // Prevent navigating away when we're checking out an order or checking if it exists
            if (this.order && this.order.checkout_in_progress) {

                // Prevent navigating if
                // - Current page is Processing - We're currently checking if the order exists
                // - Current page is Pay and we're going anywhere except Processing - Keep the user on the page but
                // allow our automatic redirect to Processing
                const prevent_navigation = from.name == 'Processing' ||
                    (from.name == 'Pay' && to.name != 'Processing')
                if (prevent_navigation) {
                    console.log(`prevented navigation from ${from.name} to ${to.name} due to checkout in progress`)
                    return next(false)
                }
            }

            // On route change, reset the page_stack to the next route
            map_route_stack(to)
            next()
        })

        this.$router.afterEach((to, from, next) => {
            // The outlet component contains a child component with
            // a Google Maps widget. Prevent opening the sidebar on
            // touch pan when this map is visible.
            this.sidebar_swipeable = to.name != 'Outlet'
        })
    },

    mounted() {

        if (this.$route.name == 'Menu')
            this.setAllowPopup()
    },

    data () {
        return {
            app: this.$root.$data.app,
            page_stack: [],
            sidebar_swipeable: true,
        }
    },

    methods : {

        ...mapMutations([
            'logout',
            'setSidebarOpen',
            'setAllowPopup',
        ]),

        ...mapActions([
            'refreshOutlet',
        ]),

        /* Override default pop behavior and delegate it to the router */
        goBack() {
            // Go to the parent route component
            console.log('goback')
            this.$router.push({ name: this.$route.matched[this.$route.matched.length - 2].name });
        },

        home(){
            this.$router.push({ name: 'Outlets' })
            this.setSidebarOpen(false)
        },

        menu(){
            this.$router.push({ name: 'Menu' })
            this.setSidebarOpen(false)
        },

        myAccount(){
            this.$router.push({ name: 'User' })
            this.setSidebarOpen(false)
        },

        orders(){
            this.$router.push({ name: 'Orders' })
            this.setSidebarOpen(false)
        },

        signout(){
            this.logout()
            this.$router.push(this.app.homeRoute())
            this.setSidebarOpen(false)
            this.$ons.notification.toast('You have logged out', { timeout: 2000 })
        },

        login(){
            this.$router.push({ name: 'Login' })
            this.setSidebarOpen(false)
        },

        eula(){
            this.$router.push({ name: 'EULA' })
            this.setSidebarOpen(false)
        },

        licenses(){
            this.$router.push({ name: 'Licenses' })
            this.setSidebarOpen(false)
        },
    },

    computed: {
        ...mapGetters([
            'user',
            'sidebarOpen',
            'embed',
            'basketInfo',
            'browse_only',
            'order',
        ])
    },

    watch: {

        '$route'(new_val, old_val){
            if(new_val.name == 'Menu') {
                this.setAllowPopup()
            } else {
                this.setAllowPopup(false)
            }
        },

        'basketInfo.amounts.total': function(new_basket, old_basket){
            this.refreshOutlet()
        },

        user(new_user, old_user){
            // Detect logout, not currently used
            // if (new_user == null && old_user != null){ }
        }
    }
}
</script>

<style scoped>
    .logo {
        display: block;
        width: 100%;
        padding: 15px;
    }

    ons-list-item {
        cursor: pointer;
    }

    a, a:visited {
        color: rgb(31, 48, 63);
    }
</style>

<style>
    ons-list-item button i {
        color: #62D6B6;
    }

    .for-businesses-link {
        justify-content: center;
    }
</style>


// WEBPACK FOOTER //
// src/js/components/base.vue